import {
  Ionicons,
  MaterialCommunityIcons,
  MaterialIcons,
} from "@expo/vector-icons";

import {
  DrawerContentScrollView,
  DrawerItem,
  DrawerItemList,
  createDrawerNavigator,
} from "@react-navigation/drawer";
import { Button, Divider } from "@towersystems/roam-common-native";
import Constants from "expo-constants";
import { useTranslation } from "react-i18next";
import { Linking, View } from "react-native";
import { Colors, Spacings } from "react-native-ui-lib";
import { CurrentUserCard } from "../../../../components";
import { useAuthenticationProvider } from "@towersystems/roam-common-native/lib/utilities/authentication";
import { keys } from "../../../../utilities/i18n";
import { PhotoImageRootScreen } from "../../../photo-image";
import { SettingsRootScreen } from "../../../settings/screens/SettingsRootScreen";

export interface RootStackProps {}

const drawerStyles = {
  fontSize: 17,
  borderRadius: 10,
  fontFamily: "Gilmer-Medium",
};

const commonIconProps = {
  size: 16,
} as any;

const commonIconWrapperProps = {
  style: {
    justifyContent: "center",
    alignItems: "center",
    width: 30,
    height: 30,
  },
} as any;

const Drawer = createDrawerNavigator<any>();

export function RootStack() {
  const { t } = useTranslation();
  const authentication = useAuthenticationProvider();

  return (
    <Drawer.Navigator
      useLegacyImplementation={false}
      drawerContent={(props) => {
        return (
          <DrawerContentScrollView
            contentContainerStyle={{
              justifyContent: "space-between",
              minHeight: "100%",
            }}
          >
            <View style={{ padding: Spacings.s4 }}>
              <CurrentUserCard />
              <Divider marginBottom={0} />
            </View>
            <View style={{ flex: 1 }}>
              <DrawerItemList {...props} />
              <DrawerItem
                labelStyle={{ ...drawerStyles, color: Colors.text }}
                label="Point of Sale"
                onPress={() =>
                  Linking.openURL(
                    `${Constants.manifest?.extra?.posUrl}?auth=${authentication.token}`
                  )
                }
                icon={({ color }) => (
                  <View {...commonIconWrapperProps}>
                    <MaterialIcons
                      color={color}
                      name="point-of-sale"
                      {...commonIconProps}
                    />
                  </View>
                )}
              />
            </View>
            <View style={{ padding: Spacings.s4 }}>
              <Button
                label="Logout"
                size="compact"
                variant="outline"
                onPress={() => authentication.logout()}
                icon={
                  <MaterialCommunityIcons
                    name="logout-variant"
                    size={20}
                    color="#000000070"
                  />
                }
              />
            </View>
          </DrawerContentScrollView>
        );
      }}
      id="LeftDrawer"
      screenOptions={{
        drawerType: "front",
        unmountOnBlur: true,
        drawerStyle: {
          backgroundColor: Colors.surface,
        },
        drawerLabelStyle: [drawerStyles],
        drawerActiveBackgroundColor: "#EBEBEB",
        drawerInactiveTintColor: Colors.text,
        headerShown: false,
        sceneContainerStyle: {
          overflow: "hidden",
          backgroundColor: Colors.surface,
          height: "100%",
        },
      }}
    >
      <Drawer.Screen
        name="PhotoImageRootScreen"
        options={{
          headerShown: false,
          drawerLabel: t(keys.photoCapture),
          drawerIcon: ({ color }) => (
            <View {...commonIconWrapperProps}>
              <MaterialIcons
                color={color}
                name="camera-alt"
                {...commonIconProps}
              />
            </View>
          ),
        }}
        component={PhotoImageRootScreen}
      />
      <Drawer.Screen
        name="SettingsRootScreen"
        options={{
          headerShown: false,
          drawerLabel: "Settings",
          drawerIcon: ({ color }) => (
            <View {...commonIconWrapperProps}>
              <Ionicons
                color={color}
                name="settings-outline"
                {...commonIconProps}
              />
            </View>
          ),
        }}
        component={SettingsRootScreen}
      />
    </Drawer.Navigator>
  );
}
